export default "__VITE_ASSET__B89vkBr7__"